import restGql from 'graphql-tag';

export const GetSessions = restGql`#graphql
    query GetSessions($institutionId:String!, $includeHiddenByUser: Boolean!) {
        result(institutionId: $institutionId) @rest(
            type: "GetSession",
            method: "GET",
            path: "/v2/sessions?behaviors=1&institutionId={args.institutionId}&includeHiddenByUser={args.includeHiddenByUser}"            
        ) {
            sessions{
                id
                flexibleHours
                availability{
                    day
                    start
                    end
                }
            }
        }
    }
`;
